import "./GetAQuote.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartYourTransformation from "./sections/StartYourTransformation";
import DirectLine from "./sections/DirectLine";
import SiteFooter from "@/reusable_sections/Footer";
export default function GetAQuotePage() {
  return <div>
      <MainNavigation />
      <StartYourTransformation />
      <DirectLine />
      <SiteFooter />
    </div>;
}